/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AccountRequest } from '../models';
import { AccountViewIEnumerableResponse } from '../models';
import { BankBranchRequest } from '../models';
import { BankBranchViewIEnumerableResponse } from '../models';
import { BooleanResponse } from '../models';
/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountDeleteAccountAccountIdDelete: async (accountId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling apiV1AccountDeleteAccountAccountIdDelete.');
            }
            const localVarPath = `/api/v1/Account/DeleteAccount/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns Classification Types
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountGetAccountsByPracticeIdPracticeIdGet: async (practiceId: number, accountTypeId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1AccountGetAccountsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Account/GetAccountsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountTypeId !== undefined) {
                localVarQueryParameter['accountTypeId'] = accountTypeId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BankBranchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountGetBankBranchByKeywordSearchPost: async (body?: BankBranchRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Account/GetBankBranchByKeywordSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountSaveAccountPost: async (body?: AccountRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Account/SaveAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountDeleteAccountAccountIdDelete(accountId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV1AccountDeleteAccountAccountIdDelete(accountId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns Classification Types
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountViewIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV1AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {BankBranchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountGetBankBranchByKeywordSearchPost(body?: BankBranchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankBranchViewIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV1AccountGetBankBranchByKeywordSearchPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {AccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountSaveAccountPost(body?: AccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV1AccountSaveAccountPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountDeleteAccountAccountIdDelete(accountId: number, options?: any): AxiosPromise<BooleanResponse> {
            return AccountApiFp(configuration).apiV1AccountDeleteAccountAccountIdDelete(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns Classification Types
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any): AxiosPromise<AccountViewIEnumerableResponse> {
            return AccountApiFp(configuration).apiV1AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BankBranchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountGetBankBranchByKeywordSearchPost(body?: BankBranchRequest, options?: any): AxiosPromise<BankBranchViewIEnumerableResponse> {
            return AccountApiFp(configuration).apiV1AccountGetBankBranchByKeywordSearchPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountSaveAccountPost(body?: AccountRequest, options?: any): AxiosPromise<BooleanResponse> {
            return AccountApiFp(configuration).apiV1AccountSaveAccountPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountDeleteAccountAccountIdDelete(accountId: number, options?: any) {
        return AccountApiFp(this.configuration).apiV1AccountDeleteAccountAccountIdDelete(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns Classification Types
     * @param {number} practiceId 
     * @param {number} [accountTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any) {
        return AccountApiFp(this.configuration).apiV1AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {BankBranchRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountGetBankBranchByKeywordSearchPost(body?: BankBranchRequest, options?: any) {
        return AccountApiFp(this.configuration).apiV1AccountGetBankBranchByKeywordSearchPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {AccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountSaveAccountPost(body?: AccountRequest, options?: any) {
        return AccountApiFp(this.configuration).apiV1AccountSaveAccountPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
